export const getOrderLabelErrorMessage = (error) => {
  if (error?.status === 401 || error?.status === 403) {
    return 'Your session has expired or you do not have access to these orders. Return to Dashboard and sign in again.';
  }
  const message = error?.data?.message || error?.message;
  return typeof message === 'string' && message.trim()
    ? message.slice(0, 1500)
    : 'Could not prepare the selected orders. Return to Dashboard and try again.';
};

